import React from 'react';

import { OfficePrimitiveParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';
import { WithAccountContext } from '~/contexts/AccountContext';
import { WithBaseActionContextProps } from '~/scenes/Automation/Flows/Actions/BaseActionContext';

import { Dropdown } from '~/components/Inputs';
import { withAccountContext } from '~/contexts/AccountContext';
import { withBaseActionContext } from '~/scenes/Automation/Flows/Actions/BaseActionContext';
import FlowContext from '~/scenes/Automation/Flows/FlowContext';
import Catalog from '~/Catalog';

import TEST_ID from './OfficePrimitiveParameterValueComponent.testid';

const text = {
  officeLabel: Catalog.noOffice,
  requiredField: Catalog.requiredField,
};
type MyProps = {
  value: OfficePrimitiveParameterValue;
  onChange: (newValue: OfficePrimitiveParameterValue) => void;
  isMandatory?: boolean;
};
type WithoutAccountContextProps = WithBaseActionContextProps & MyProps;
type Props = WithAccountContext & WithoutAccountContextProps;
type State = {
  key: string | null;
};
class OfficePrimitiveParameterValueComponent extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);

    this.state = {
      key: null,
    };
  }

  componentDidMount() {
    const { baseActionContext } = this.props;

    const key = baseActionContext.subscribeValidator({
      validate: this.validate,
    });

    this.setState({
      key,
    });
  }

  componentWillUnmount() {
    const { baseActionContext } = this.props;

    if (this.state.key != null) {
      baseActionContext.unsubscribeValidator(this.state.key);
    }
  }

  validate = () => {
    const { value, isMandatory } = this.props;

    if (value.value === undefined) {
      return false;
    }

    if (isMandatory === true && value.value == null) {
      return false;
    }

    return true;
  };

  render() {
    const { value, onChange, accountContext } = this.props;
    const { value: inputValue } = value;
    const { viewableOffices } = accountContext;

    const options = viewableOffices.map(office => ({
      label: office.name,
      payload: office,
      key: office.id,
    }));

    const selectedIdx = options.findIndex(option => {
      if (option.payload === null) {
        return inputValue === null;
      } else {
        return option.payload.id === inputValue;
      }
    });

    return (
      <FlowContext.Consumer>
        {({ showValidation }) => (
          <Dropdown
            label={text.officeLabel}
            dataTestid={TEST_ID.DROPDOWN}
            options={options}
            selectedOptionIdx={selectedIdx}
            error={showValidation && !this.validate() ? text.requiredField : ''}
            onChange={({ option }) => {
              const newId = option.payload == null ? null : option.payload.id;

              if (value.value !== newId) {
                const newValue = {
                  ...value,
                  value: option.payload == null ? null : newId,
                };

                onChange(newValue);
              }
            }}
          />
        )}
      </FlowContext.Consumer>
    );
  }
}

export default withAccountContext<MyProps>(
  withBaseActionContext<WithoutAccountContextProps>(
    OfficePrimitiveParameterValueComponent,
  ),
);
